import {StyleSheet} from 'react-native';
import {BS_CARD_TYPES} from '../../../utils/Constants';

// Theme-aware styles factory (docs/DARK-MODE.md). Style-as-function entries
// are preserved — the factory returns them closed over the theme's colors.
const makeStyles = colors =>
  StyleSheet.create({
    container: variation => ({
      flex: 1,
      backgroundColor: colors.surface,
      borderWidth: 1,
      borderColor: colors.backgroundMuted,
      borderRadius: 16,
      margin: 8,
      padding: 16,
      paddingBottom: variation === BS_CARD_TYPES.SwipableCard ? 0 : 16,
      shadowRadius: 16,
      height: 100,
      shadowColor: colors.shadow,
      shadowOffset: {height: 0, width: 0},
      shadowOpacity: 0.24,
    }),
    circleContainer: {
      flex: 1,
      alignItems: 'center',
      justifyContent: 'center',
      marginHorizontal: -24,
    },
    smallCardTitle: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    smallCard: {
      flex: 1,
      flexDirection: 'column',
      justifyContent: 'space-between',
    },
  });

export default makeStyles;
